import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { useGetRolesByUser } from '@/queries/roles/useGetRolesByUser'
import { PremiumFeatures } from '@/services/types/premiumFeatures/premiumFeatures'
import { ROLES_IDS, RolesTypes } from '@/services/types/userRoles/mockRole'
import { usePremiumFeaturesPermissions } from '@/stores/permissions/premiumFeatures'

export const useToastIntegrationPermissions = () => {
  const { userId, isMarqiiUser } = useCognitoAuth()
  const userRoles = useGetRolesByUser(userId)
  const premiumFeaturesPermissions = usePremiumFeaturesPermissions()

  const hasMenusFeature = premiumFeaturesPermissions.includes(PremiumFeatures.Menus)

  const isFullControlRole =
    userRoles.data?.some(({ role }) => role.id === ROLES_IDS[RolesTypes.fullControl]) ?? false

  const isLocationManagerRole =
    userRoles.data?.some(({ role }) => role.id === ROLES_IDS[RolesTypes.locationManager]) ?? false

  const canSeeToastIntegration =
    hasMenusFeature && (isMarqiiUser || isFullControlRole || isLocationManagerRole)

  const canManageToastIntegration = hasMenusFeature && (isMarqiiUser || isFullControlRole)

  return {
    canSeeToastIntegration,
    canManageToastIntegration,
    isLoading: userRoles.isLoading,
  }
}
